<template>
  <div class="app-container">
    <el-card shadow="never" class="query-card">
      <el-form :model="query" ref="queryForm" :inline="true" v-show="showSearch">
        <el-form-item label="用户名称" prop="username">
          <el-input
            v-model="query.username"
            placeholder="请输入用户名称"
            clearable
            size="small"
            style="width: 240px"
            @keyup.enter.native="handleQuery"
          />
        </el-form-item>
        <el-form-item label="手机号码" prop="phone">
          <el-input
            v-model="query.phone"
            placeholder="请输入手机号码"
            clearable
            size="small"
            style="width: 240px"
            @keyup.enter.native="handleQuery"
          />
        </el-form-item>
        <el-form-item label="状态" prop="status">
          <el-select
            v-model="query.status"
            placeholder="用户状态"
            clearable
            size="small"
            style="width: 240px"
          >
            <el-option label="正常" :value="1" />
            <el-option label="停用" :value="0" />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" size="mini" @click="handleQuery">搜索</el-button>
          <el-button icon="el-icon-refresh" size="mini" @click="resetQuery">重置</el-button>
        </el-form-item>
        <!-- 与搜索同一行：不用 v-hasPermi（避免菜单 perms 未挂全导致 display:none）；接口侧仍有鉴权 -->
        <el-form-item label="投放同步">
          <el-button
            v-if="isSuperAdminViewer"
            type="primary"
            plain
            size="mini"
            icon="el-icon-upload2"
            @click="openSyncDialog"
          >从A同步用户</el-button>
          <el-button
            size="mini"
            icon="el-icon-connection"
            @click="openUserBindLookup"
          >投放用户ID映射</el-button>
        </el-form-item>
      </el-form>

      <table-operations
        @add="handleAdd"
        :show-edit="true"
        :add-permi="['system:user:create']"
        :disable-edit="single"
        :edit-permi="['system:user:update']"
        @edit="handleUpdate"
        :show-delete="true"
        :disable-delete="multiple"
        :delete-permi="['system:user:delete']"
        @delete="handleDelete"
        :show-export="true"
        :export-permi="['system:user:export']"
        @export="handleExport"
      >
        <template slot="right-toolbar">
          <right-toolbar :showSearch.sync="showSearch" @queryTable="fetchList"></right-toolbar>
        </template>
      </table-operations>

      <el-table v-loading="loading" :data="userList" @selection-change="handleSelectionChange" border>
        <el-table-column type="selection" width="55" align="center" />
        <el-table-column label="用户编号" prop="id" width="120" />
        <el-table-column label="用户名称" prop="username" :show-overflow-tooltip="true" />
        <el-table-column label="用户昵称" prop="nickname" :show-overflow-tooltip="true" />
        <el-table-column label="部门" prop="deptId" :show-overflow-tooltip="true">
            <template slot-scope="scope">
                {{ scope.row.deptName || '-' }}
            </template>
        </el-table-column>
        <el-table-column label="角色" prop="roleNames" :show-overflow-tooltip="true">
            <template slot-scope="scope">
                {{ scope.row.roleNames || '-' }}
            </template>
        </el-table-column>
        <el-table-column label="手机号码" prop="phone" width="120" />
        <el-table-column label="状态" align="center" width="100">
          <template slot-scope="scope">
            <el-switch
              v-model="scope.row.status"
              :active-value="1"
              :inactive-value="0"
              :disabled="!canUpdateUser"
              @change="handleStatusChange(scope.row)"
            ></el-switch>
          </template>
        </el-table-column>
        <el-table-column label="创建时间" align="center" prop="createTime" width="180">
          <template slot-scope="scope">
            <span>{{ parseTime(scope.row.createTime) }}</span>
          </template>
        </el-table-column>
        <el-table-column v-if="hasUserActions" label="操作" align="center" class-name="small-padding fixed-width" width="180">
          <template slot-scope="scope">
            <div class="operation-cell">
              <el-button
                v-if="canUpdateUser"
                size="mini"
                type="text"
                icon="el-icon-edit"
                @click="handleUpdate(scope.row)"
              >修改</el-button>
              <el-button
                v-if="canDeleteUser"
                size="mini"
                type="text"
                icon="el-icon-delete"
                class="danger-text"
                @click="handleDelete(scope.row)"
              >删除</el-button>
              <el-dropdown v-if="canResetPassword || canManageUserRoles" size="mini" @command="(command) => handleCommand(command, scope.row)">
                <span class="el-dropdown-link">
                  <i class="el-icon-d-arrow-right el-icon--right"></i>更多
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item v-if="canResetPassword" command="handleResetPwd" icon="el-icon-key">重置密码</el-dropdown-item>
                  <el-dropdown-item v-if="canManageUserRoles" command="handleRole" icon="el-icon-circle-check">分配角色</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </template>
        </el-table-column>
      </el-table>

      <pagination
        v-show="total>0"
        :total="total"
        :page.sync="pageNo"
        :limit.sync="pageSize"
        @pagination="fetchList"
      />
    </el-card>

    <!-- 添加或修改用户对话框 -->
    <el-dialog :title="title" :visible.sync="open" width="720px" append-to-body>
      <el-form ref="form" :model="form" :rules="rules" label-width="80px">
        <el-row>
          <el-col :span="12">
            <el-form-item label="用户昵称" prop="nickname">
              <el-input v-model="form.nickname" placeholder="请输入用户昵称" maxlength="30" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="归属部门" prop="deptId">
              <div v-if="isDistributorManagerUser" style="color:#909399;font-size:12px;line-height:1.4;margin-bottom:8px;">
                分销管理员创建用户时，部门固定为当前所在部门。
              </div>
               <el-cascader
                v-model="form.deptId"
                :options="deptOptions"
                :props="{ value: 'id', label: 'deptName', children: 'children', checkStrictly: true, emitPath: false }"
                :disabled="isDistributorManagerUser"
                clearable
                placeholder="选择归属部门"
                style="width: 100%"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="手机号码" prop="phone">
              <el-input v-model="form.phone" placeholder="请输入手机号码" maxlength="11" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="邮箱" prop="email">
              <el-input v-model="form.email" placeholder="请输入邮箱" maxlength="50" />
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="form.id == undefined">
            <el-form-item label="用户名称" prop="username">
              <el-input v-model="form.username" placeholder="请输入用户名称" maxlength="30" />
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="form.id == undefined">
            <el-form-item label="用户密码" prop="password">
              <el-input v-model="form.password" placeholder="请输入用户密码" type="password" maxlength="20" show-password />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="用户性别">
              <el-select v-model="form.sex" placeholder="请选择性别" style="width: 100%">
                <el-option label="男" :value="1" />
                <el-option label="女" :value="2" />
                <el-option label="未知" :value="0" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="状态">
              <el-radio-group v-model="form.status">
                <el-radio :label="1">正常</el-radio>
                <el-radio :label="0">停用</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="归属角色">
              <div v-if="isDistributorManagerUser" style="color:#909399;font-size:12px;line-height:1.4;margin-bottom:8px;">
                可在「分销管理员」与「分销员」中选择（可多选）；默认勾选分销员。
              </div>
              <el-select v-model="form.roleIds" multiple placeholder="请选择角色" style="width: 100%">
                <el-option v-for="role in roleOptions" :key="role.id" :label="role.name" :value="role.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col v-if="canManageAdsBinds" :span="24">
            <el-form-item label="投放用户ID">
              <div style="color:#909399;font-size:12px;line-height:1.4;margin-bottom:8px;">
                旧投放系统（A）用户主键，可添加多个；策略分析等将按此与 A 侧策略归属对齐。同一 ID 全局仅能绑定到一个本系统账号。
                <el-button type="text" size="mini" icon="el-icon-search" @click="openUserBindLookup">查映射表</el-button>
              </div>
              <div v-for="(val, idx) in adsBindRows" :key="'ads-' + idx" style="margin-bottom:8px;display:flex;align-items:center;gap:8px;">
                <el-input-number
                  v-model="adsBindRows[idx]"
                  :min="1"
                  :precision="0"
                  placeholder="旧系统用户ID"
                  :controls="false"
                  style="width:240px"
                />
                <el-button type="text" icon="el-icon-delete" class="danger-text" @click="removeAdsRow(idx)">移除</el-button>
              </div>
              <el-button type="primary" plain size="mini" icon="el-icon-plus" @click="addAdsRow">添加一行</el-button>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="备注">
              <el-input v-model="form.remark" type="textarea" placeholder="请输入内容"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitForm">确 定</el-button>
        <el-button @click="cancel">取 消</el-button>
      </div>
    </el-dialog>

    <!-- 从 A：先选投放部门 → 导入到本系统 → 再同步人员 -->
    <el-dialog
      v-el-drag-dialog
      title="从投放系统同步用户"
      :visible.sync="syncDialogVisible"
      width="920px"
      append-to-body
      @open="onSyncDialogOpen"
    >
      <div style="color:#303133;font-weight:600;margin-bottom:8px;">第一步：在投放系统（A）选部门 → 本系统新建部门 → 写入 A↔B 绑定</div>
      <div style="color:#909399;font-size:12px;margin-bottom:10px;line-height:1.5;">
        左侧树由 A 实时拉取，并显示<strong>本系统是否已绑定</strong>。未绑定的部门可选中后指定本系统父部门，再点「导入到本系统」完成<strong>两步</strong>：① 在 B 创建新部门 ② 与所选 A 部门建立 <code>sys_dept_ads_bind</code>。已绑定行无需再导入。用户ID=1 可不选父部门（挂在根）。第二步「同步人员」依赖该绑定；若某 A 用户在本系统已有映射或登录名已存在则跳过。新用户默认密码 <strong>123456</strong>。
      </div>
      <el-row :gutter="16" style="margin-bottom:16px;">
        <el-col :span="14">
          <el-form :inline="true" size="small" style="margin-bottom:8px;" @submit.native.prevent="applyAdsDeptFilter">
            <el-form-item label="查询">
              <el-input
                v-model="adsDeptKeyword"
                placeholder="部门名称或投放部门ID"
                clearable
                style="width:200px"
                @keyup.enter.native="applyAdsDeptFilter"
                @clear="applyAdsDeptFilter"
              />
            </el-form-item>
            <el-form-item>
              <el-button type="primary" size="mini" icon="el-icon-search" @click="applyAdsDeptFilter">筛选</el-button>
            </el-form-item>
          </el-form>
          <div style="margin-bottom:6px;font-size:13px;color:#606266;">投放系统部门（点击行选中；已绑定显示本系统部门）</div>
          <el-table
            v-loading="adsDeptTreeLoading"
            :data="adsDeptTree"
            row-key="deptId"
            border
            size="small"
            max-height="280"
            highlight-current-row
            :tree-props="{ children: 'children' }"
            default-expand-all
            @row-click="handleAdsDeptRowClick"
          >
            <el-table-column prop="deptName" label="投放部门名称" min-width="160" show-overflow-tooltip />
            <el-table-column prop="deptId" label="投放部门ID" width="100" align="center" />
            <el-table-column label="绑定" width="88" align="center">
              <template slot-scope="scope">
                <el-tag v-if="scope.row.bound" type="success" size="mini">已绑定</el-tag>
                <el-tag v-else type="info" size="mini">未绑定</el-tag>
              </template>
            </el-table-column>
            <el-table-column label="本系统部门(B)" min-width="140" show-overflow-tooltip>
              <template slot-scope="scope">
                <span v-if="scope.row.bound">{{ scope.row.bDeptName || '—' }}（ID {{ scope.row.aiDeptId }}）</span>
                <span v-else style="color:#909399;">—</span>
              </template>
            </el-table-column>
          </el-table>
        </el-col>
        <el-col :span="10">
          <el-form size="small" label-width="108px">
            <el-form-item label="本系统父部门">
              <el-cascader
                v-model="importParentDeptId"
                :options="deptOptions"
                :props="{ value: 'id', label: 'deptName', children: 'children', checkStrictly: true, emitPath: false }"
                clearable
                placeholder="选择父部门"
                style="width: 100%"
              />
              <div style="color:#909399;font-size:12px;margin-top:4px;">可不选，将创建在根下</div>
            </el-form-item>
            <el-form-item label="当前选中">
              <span v-if="selectedAdsDeptRow">
                {{ selectedAdsDeptRow.deptName }}（投放ID {{ selectedAdsDeptRow.deptId }}）
                <span v-if="selectedAdsDeptRow.bound" style="color:#E6A23C;">（已绑定）</span>
              </span>
              <span v-else style="color:#909399;">请在左侧点击一行</span>
            </el-form-item>
            <el-form-item label="绑定到已有部门">
              <el-cascader
                v-model="bindExistDeptId"
                :options="deptOptions"
                :props="{ value: 'id', label: 'deptName', children: 'children', checkStrictly: true, emitPath: false }"
                clearable
                placeholder="选择B系统已有部门"
                style="width: 100%"
              />
            </el-form-item>
            <el-form-item>
              <el-button
                type="success"
                size="small"
                :loading="bindExistSubmitting"
                :disabled="!selectedAdsDeptRow || !bindExistDeptId || selectedAdsDeptRow.bound"
                @click="handleBindExistDept"
              >绑定到已有部门</el-button>
              <el-button
                type="primary"
                size="small"
                :loading="importDeptSubmitting"
                :disabled="!selectedAdsDeptRow || !canSyncFromAds || selectedAdsDeptRow.bound"
                @click="handleImportAdsDept"
              >导入（新建部门）</el-button>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>

      <el-divider content-position="left">第二步：已关联部门 — 同步人员</el-divider>
      <div style="color:#909399;font-size:12px;margin-bottom:10px;">
        以下为 <code>sys_dept_ads_bind</code> 中的映射。点击「同步人员」按绑定关系从 A 拉取该部门用户：若 <code>sys_user_ads_bind</code> 已有该 A 用户或本系统已有同登录名则跳过；否则新建用户并写绑定。
      </div>
      <el-alert
        v-if="!deptBindLoading && deptBindTotal === 0 && !(deptBindQuery.keyword && String(deptBindQuery.keyword).trim())"
        title="当前没有已关联的部门"
        type="info"
        :closable="false"
        show-icon
        style="margin-bottom:12px;"
      >
        <span style="font-size:13px;">请先在上方完成<strong>导入部门</strong>；若仍为空，请确认当前为内置超级管理员（用户ID=1）查看。</span>
      </el-alert>
      <el-alert
        v-if="!deptBindLoading && deptBindTotal === 0 && (deptBindQuery.keyword && String(deptBindQuery.keyword).trim())"
        title="无匹配结果"
        type="info"
        :closable="false"
        show-icon
        style="margin-bottom:12px;"
      >
        请尝试清空筛选或更换关键词（B 部门名、A/B 部门数字 ID）。
      </el-alert>
      <el-form :inline="true" size="small" @submit.native.prevent="handleDeptBindSearch">
        <el-form-item label="筛选">
          <el-input
            v-model="deptBindQuery.keyword"
            placeholder="B部门名 / A或B部门数字ID"
            clearable
            style="width:260px"
            @keyup.enter.native="handleDeptBindSearch"
          />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="handleDeptBindSearch">搜索</el-button>
        </el-form-item>
      </el-form>
      <el-table v-loading="deptBindLoading" :data="deptBindList" border size="small" max-height="360">
        <el-table-column label="B部门名称" prop="aiDeptName" min-width="140" show-overflow-tooltip />
        <el-table-column label="B部门ID(同步用)" prop="aiDeptId" width="120" align="center" />
        <el-table-column label="A部门ID" prop="adsDeptId" width="100" align="center" />
        <el-table-column label="A部门名称" prop="adsDeptName" min-width="120" show-overflow-tooltip />
        <el-table-column label="创建时间" width="160" align="center">
          <template slot-scope="scope">
            <span>{{ parseTime(scope.row.createdAt) }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="160" align="center" fixed="right">
          <template slot-scope="scope">
            <el-button
              type="text"
              size="mini"
              :disabled="!canSyncFromAds"
              :loading="scope.row._syncing"
              @click="handleSyncOneDept(scope.row)"
            >同步人员</el-button>
            <el-button
              v-if="isSuperAdminViewer"
              type="text"
              size="mini"
              class="danger-text"
              @click="handleDeleteDeptBind(scope.row)"
            >解除绑定</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div style="margin-top:12px;text-align:right;">
        <el-pagination
          small
          layout="total, prev, pager, next"
          :total="deptBindTotal"
          :page-size="deptBindQuery.pageSize"
          :current-page="deptBindQuery.pageNo"
          @current-change="handleDeptBindPageChange"
        />
      </div>
    </el-dialog>

    <!-- 用户与 A 用户 ID 映射查询 -->
    <el-dialog
      v-el-drag-dialog
      title="投放用户ID映射（管理）"
      :visible.sync="userBindDialogVisible"
      width="1080px"
      append-to-body
      @open="onUserBindDialogOpen"
    >
      <div style="color:#909399;font-size:12px;margin-bottom:12px;">
        可按登录名、昵称或本系统/A 侧用户数字 ID 筛选。列表中「本系统」为 B 侧账号，「投放(A)」为旧投放系统账号；A 侧登录名/昵称由 B 调用投放接口实时填充（需配置 ads-backend）。
      </div>
      <el-form :inline="true" size="small" @submit.native.prevent="handleUserBindSearch">
        <el-form-item label="筛选">
          <el-input
            v-model="userBindQuery.keyword"
            placeholder="用户名 / 昵称 / 用户ID"
            clearable
            style="width:260px"
            @keyup.enter.native="handleUserBindSearch"
          />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="handleUserBindSearch">搜索</el-button>
        </el-form-item>
        <el-form-item v-if="isSuperAdminViewer">
          <el-button type="success" icon="el-icon-setting" size="mini" @click="openAddUserBindDialog">管理映射</el-button>
        </el-form-item>
      </el-form>
      <el-table v-loading="userBindLoading" :data="userBindList" border size="small" max-height="400">
        <el-table-column label="本系统登录名" prop="username" width="120" show-overflow-tooltip />
        <el-table-column label="本系统昵称" prop="nickname" width="120" show-overflow-tooltip />
        <el-table-column label="本系统用户ID" prop="sysUserId" width="110" align="center" />
        <el-table-column label="投放登录名(A)" width="120" show-overflow-tooltip>
          <template slot-scope="scope">
            <span>{{ scope.row.adsUsername || '—' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="投放昵称(A)" width="120" show-overflow-tooltip>
          <template slot-scope="scope">
            <span>{{ scope.row.adsNickname || '—' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="投放用户ID(A)" prop="adsUserId" width="120" align="center" />
        <el-table-column label="部门" prop="deptName" min-width="120" show-overflow-tooltip />
        <el-table-column label="绑定时间" width="160" align="center">
          <template slot-scope="scope">
            <span>{{ parseTime(scope.row.createdAt) }}</span>
          </template>
        </el-table-column>
        <el-table-column v-if="isSuperAdminViewer" label="操作" width="80" align="center" fixed="right">
          <template slot-scope="scope">
            <el-button type="text" size="mini" class="danger-text" @click="handleDeleteUserBind(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div style="margin-top:12px;text-align:right;">
        <el-pagination
          small
          layout="total, prev, pager, next"
          :total="userBindTotal"
          :page-size="userBindQuery.pageSize"
          :current-page="userBindQuery.pageNo"
          @current-change="handleUserBindPageChange"
        />
      </div>
    </el-dialog>

    <!-- 管理用户映射（勾选 A 系统用户） -->
    <el-dialog
      v-el-drag-dialog
      title="管理用户映射"
      :visible.sync="addUserBindVisible"
      width="700px"
      append-to-body
    >
      <el-form :inline="true" size="small" style="margin-bottom:12px;">
        <el-form-item label="本系统用户" required>
          <el-select
            v-model="manageBindSysUserId"
            filterable
            placeholder="选择要管理映射的用户"
            style="width: 280px"
            @change="onManageBindUserChange"
          >
            <el-option
              v-for="u in localUserOptions"
              :key="u.id"
              :label="u.username + '（' + u.nickname + '）'"
              :value="u.id"
            />
          </el-select>
        </el-form-item>
      </el-form>
      <div v-if="manageBindSysUserId">
        <div style="color:#606266;margin-bottom:8px;font-size:13px;">
          以下是已绑定 A 部门中的用户列表，勾选表示映射到当前 B 用户，取消勾选表示解除映射。
        </div>
        <el-table
          v-loading="manageBindAdsUsersLoading"
          :data="manageBindAdsUsers"
          border
          size="small"
          max-height="350"
          @selection-change="onManageBindSelectionChange"
          ref="manageBindTable"
        >
          <el-table-column type="selection" width="50" align="center" />
          <el-table-column label="A系统登录名" prop="userName" min-width="120" show-overflow-tooltip />
          <el-table-column label="A系统昵称" prop="nickName" min-width="120" show-overflow-tooltip />
          <el-table-column label="A系统用户ID" prop="userId" width="110" align="center" />
          <el-table-column label="A系统角色" prop="roleKeys" min-width="100" show-overflow-tooltip />
        </el-table>
        <div v-if="!manageBindAdsUsersLoading && manageBindAdsUsers.length === 0" style="color:#909399;font-size:13px;margin-top:8px;">
          未获取到 A 系统用户数据，请检查 ads-backend 配置是否正确。
        </div>
      </div>
      <div v-else style="color:#909399;font-size:13px;padding:20px 0;text-align:center;">
        请先在上方选择一个本系统用户
      </div>
      <div slot="footer">
        <el-button @click="addUserBindVisible = false">取消</el-button>
        <el-button type="primary" :loading="addUserBindSubmitting" :disabled="!manageBindSysUserId" @click="submitManageBind">保存映射</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { listUsers, createUser, updateUser, deleteUsers, getUserRoleIds, listAdsBinds, saveAdsBinds, getAssignableRoles, syncFromAdsDept } from '@/api/system/user';
import { listDeptAdsBinds, listUserAdsBinds, fetchAdsDeptTree, importAdsDept, createUserAdsBind, deleteUserAdsBind, deleteDeptAdsBind, listAdsDeptUsers, batchSaveUserAdsBinds, listAllAdsUsers } from '@/api/system/adsBind';
import { getDeptTree, saveDeptAdsBind } from '@/api/system/dept';
import Pagination from "@/components/Pagination";
import RightToolbar from "@/components/RightToolbar";
import TableOperations from "@/components/TableOperations";
import { hasAllPermissions, hasAnyPermission, hasRoleCode, isSuperAdminUser } from '@/utils/permission';

export default {
  name: "User",
  components: { Pagination, RightToolbar, TableOperations },
  data() {
    return {
      // 遮罩层
      loading: true,
      // 选中数组
      ids: [],
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      // 显示搜索条件
      showSearch: true,
      // 总条数
      total: 0,
      // 用户表格数据
      userList: [],
      // 弹出层标题
      title: "",
      // 是否显示弹出层
      open: false,
      // 部门树选项
      deptOptions: [],
      // 角色列表
      roleOptions: [],
      // 查询参数
      query: {
        username: undefined,
        phone: undefined,
        status: undefined
      },
      pageNo: 1,
      pageSize: 10,
      // 表单参数
      form: {},
      /** 投放旧系统用户 ID 多行编辑（与 form 分离，保存时写入 ads-binds） */
      adsBindRows: [],
      syncDialogVisible: false,
      deptBindQuery: { keyword: '', pageNo: 1, pageSize: 10 },
      deptBindList: [],
      deptBindTotal: 0,
      deptBindLoading: false,
      /** 投放系统部门树（从 A 拉取） */
      adsDeptTree: [],
      adsDeptFlatFull: [],
      adsDeptKeyword: '',
      adsDeptTreeLoading: false,
      selectedAdsDeptRow: null,
      importParentDeptId: undefined,
      importDeptSubmitting: false,
      bindExistDeptId: undefined,
      bindExistSubmitting: false,
      userBindDialogVisible: false,
      userBindQuery: { keyword: '', pageNo: 1, pageSize: 10 },
      userBindList: [],
      userBindTotal: 0,
      userBindLoading: false,
      addUserBindVisible: false,
      addUserBindSubmitting: false,
      localUserOptions: [],
      localUserSearchLoading: false,
      manageBindSysUserId: null,
      manageBindAdsUsers: [],
      manageBindAdsUsersLoading: false,
      manageBindSelectedAdsUserIds: [],
      // 表单校验
      rules: {
        username: [
          { required: true, message: "用户名称不能为空", trigger: "blur" },
          { min: 2, max: 20, message: '用户名称长度必须介于 2 和 20 之间', trigger: 'blur' }
        ],
        nickname: [
          { required: true, message: "用户昵称不能为空", trigger: "blur" }
        ],
        password: [
          { required: true, message: "用户密码不能为空", trigger: "blur" },
          { min: 5, max: 20, message: '用户密码长度必须介于 5 和 20 之间', trigger: 'blur' }
        ],
        email: [
          {
            type: "email",
            message: "请输入正确的邮箱地址",
            trigger: ["blur", "change"]
          }
        ],
        phone: [
          {
            pattern: /^1[3|4|5|6|7|8|9][0-9]\d{8}$/,
            message: "请输入正确的手机号码",
            trigger: "blur"
          }
        ]
      }
    };
  },
  created() {
    this.getDeptTreeselect();
    this.getRoleList().finally(() => {
      this.fetchList();
    });
  },
  computed: {
    isDistributorManagerUser() {
      return hasRoleCode(this, 'distributor_manager');
    },
    canUpdateUser() {
      return hasAnyPermission(this, ['system:user:update']);
    },
    canDeleteUser() {
      return hasAnyPermission(this, ['system:user:delete']);
    },
    canResetPassword() {
      return this.canUpdateUser;
    },
    /** 修改用户时的角色展示与提交随 PUT 完成，不再单独调 POST /roles，故不需 system:user:assign_roles */
    canManageUserRoles() {
      return this.canUpdateUser && hasAllPermissions(this, ['system:user:roles']);
    },
    canManageAdsBinds() {
      return this.canUpdateUser;
    },
    hasUserActions() {
      return this.canUpdateUser || this.canDeleteUser || this.canResetPassword || this.canManageUserRoles;
    },
    isSuperAdminViewer() {
      var appVm = this.$root && this.$root.$children && this.$root.$children[0];
      var user = appVm ? appVm.currentUser : null;
      if (!user) {
        return false;
      }
      return Number(user.id) === 1 || user.isAdmin === 1 || user.isAdmin === true;
    },
    canSyncFromAds() {
      return this.isSuperAdminViewer;
    }
  },
  methods: {
    /** 查询用户列表 */
    async fetchList() {
      this.loading = true;
      try {
        const params = {
          pageNo: this.pageNo,
          pageSize: this.pageSize,
          ...this.query
        };
        const response = await listUsers(params);
        this.userList = response.data.records;
        this.total = response.data.total;
      } finally {
        this.loading = false;
      }
    },
    /** 查询部门树结构（无权限时静默降级） */
    async getDeptTreeselect() {
      try {
        const response = await getDeptTree(null, { skipErrorMessage: true });
        this.deptOptions = response.data || [];
      } catch (e) {
        this.deptOptions = [];
      }
    },
    /** 查询可分配角色列表 */
    async getRoleList() {
      try {
        const response = await getAssignableRoles({ skipErrorMessage: true });
        this.roleOptions = response.data || [];
      } catch (e) {
        this.roleOptions = [];
      }
    },
    /** 用户状态修改 */
    handleStatusChange(row) {
      if (!this.canUpdateUser) {
        row.status = row.status === 1 ? 0 : 1;
        return;
      }
      let text = row.status === 1 ? "启用" : "停用";
      this.$confirm('确认要"' + text + '""' + row.username + '"用户吗？', "警告", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(async () => {
        await updateUser(row.id, { id: row.id, status: row.status });
        this.$message.success(text + "成功");
      }).catch(function() {
        row.status = row.status === 1 ? 0 : 1;
      });
    },
    // 取消按钮
    cancel() {
      this.open = false;
      this.reset();
    },
    // 表单重置
    reset() {
      this.form = {
        id: undefined,
        deptId: undefined,
        username: undefined,
        nickname: undefined,
        password: undefined,
        phone: undefined,
        email: undefined,
        sex: undefined,
        status: 1,
        remark: undefined,
        roleIds: []
      };
      this.adsBindRows = [];
    },
    getCurrentUser() {
      return this.$root && this.$root.currentUser ? this.$root.currentUser : null;
    },
    applyScopedDefaults() {
      if (!this.isDistributorManagerUser) {
        return;
      }
      const currentUser = this.getCurrentUser();
      if (currentUser && currentUser.deptId != null) {
        this.form.deptId = currentUser.deptId;
      }
      if (this.roleOptions.length === 1) {
        this.form.roleIds = [this.roleOptions[0].id];
      } else if (this.roleOptions.length > 0) {
        var dist = this.roleOptions.find(function (r) { return r.code === 'distributor'; });
        if (dist) {
          this.form.roleIds = [dist.id];
        }
      }
    },
    addAdsRow: function() {
      this.adsBindRows.push(undefined);
    },
    removeAdsRow: function(idx) {
      this.adsBindRows.splice(idx, 1);
    },
    collectAdsUserIds: function() {
      var rows = this.adsBindRows || [];
      var out = [];
      for (var i = 0; i < rows.length; i++) {
        var v = rows[i];
        if (v != null && v !== '' && Number(v) > 0) {
          out.push(Number(v));
        }
      }
      return out;
    },
    /** 搜索按钮操作 */
    handleQuery() {
      this.pageNo = 1;
      this.fetchList();
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.query = {
        username: undefined,
        phone: undefined,
        status: undefined
      };
      this.handleQuery();
    },
    // 多选框选中数据
    handleSelectionChange(selection) {
      this.ids = selection.map(item => item.id);
      this.single = selection.length != 1;
      this.multiple = !selection.length;
    },
    /** 新增按钮操作 */
    async handleAdd() {
      this.reset();
      await this.getDeptTreeselect();
      await this.getRoleList();
      this.applyScopedDefaults();
      this.open = true;
      this.title = "添加用户";
    },
    /** 修改按钮操作 */
    async handleUpdate(row) {
      this.reset();
      await this.getDeptTreeselect();
      await this.getRoleList();
      const rawId = row.id || this.ids;
      const userId = Array.isArray(rawId) ? rawId[0] : rawId;
      const target = row.id ? row : this.userList.find(i => i.id === userId);
      this.form = { ...target, roleIds: [] };
      if (this.canManageUserRoles) {
        try {
          const roleResp = await getUserRoleIds(userId, { skipErrorMessage: true });
          this.form.roleIds = Array.isArray(roleResp) ? roleResp : (roleResp && roleResp.data) || [];
        } catch (e) {
          this.form.roleIds = [];
        }
      }
      // 投放系统用户 ID 绑定
      if (this.canManageAdsBinds) {
        try {
          const bindRes = await listAdsBinds(userId);
          var binds = (bindRes && bindRes.data) ? bindRes.data : [];
          this.adsBindRows = Array.isArray(binds) && binds.length
            ? binds.map(function(b) { return b.adsUserId; })
            : [];
        } catch (e) {
          this.adsBindRows = [];
        }
      }
      this.open = true;
      this.title = "修改用户";
    },
    /** 提交按钮 */
    submitForm() {
      this.$refs["form"].validate(async valid => {
        if (valid) {
          const adsIds = this.collectAdsUserIds();
          if (this.form.id != undefined) {
            // 角色随 PUT 一并提交（后端 replaceUserRoles），勿再调 POST /roles，否则会多一次鉴权且依赖 system:user:assign_roles
            const payload = Object.assign({}, this.form);
            if (!this.canManageUserRoles) {
              delete payload.roleIds;
            }
            await updateUser(this.form.id, payload);
            if (this.canManageAdsBinds) {
              await saveAdsBinds(this.form.id, adsIds);
            }
            this.$message.success("修改成功");
          } else {
            const payload = Object.assign({}, this.form);
            if (!this.canManageUserRoles) {
              delete payload.roleIds;
            }
            const res = await createUser(payload);
            const newId = (res && res.data && res.data.id) ? res.data.id : (res && res.data) || res;
            if (this.canManageAdsBinds && adsIds.length > 0) {
              await saveAdsBinds(newId, adsIds);
            }
            this.$message.success("新增成功");
          }
          this.open = false;
          this.fetchList();
        }
      });
    },
    /** 删除按钮操作 */
    handleDelete(row) {
      const userIds = row.id || this.ids;
      this.$confirm('是否确认删除用户编号为"' + userIds + '"的数据项？', "警告", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(async () => {
        if (Array.isArray(userIds)) {
            await deleteUsers(userIds);
        } else {
            await deleteUsers([userIds]);
        }
        this.fetchList();
        this.$message.success("删除成功");
      }).catch(() => {});
    },
    /** 导出按钮操作 */
    handleExport() {
      this.$message.info("导出功能待实现");
    },
    /** 重置密码按钮操作 */
    handleResetPwd(row) {
      this.$prompt('请输入"' + row.username + '"的新密码', "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        closeOnClickModal: false,
        inputPattern: /^.{5,20}$/,
        inputErrorMessage: "用户密码长度必须介于 5 和 20 之间"
      }).then(async ({ value }) => {
        await updateUser(row.id, { id: row.id, password: value });
        this.$message.success("修改成功，新密码是：" + value);
      }).catch(() => {});
    },
    handlePageChange(page) {
      this.pageNo = page;
      this.fetchList();
    },
    handleSizeChange(size) {
      this.pageSize = size;
      this.fetchList();
    },
    handleCommand(command, row) {
      switch (command) {
        case "handleResetPwd":
          this.handleResetPwd(row);
          break;
        case "handleRole":
          this.handleUpdate(row);
          break;
        default:
          break;
      }
    },
    parseTime(time) {
        if (!time) return '';
        const date = new Date(time);
        const y = date.getFullYear();
        const m = (date.getMonth() + 1).toString().padStart(2, '0');
        const d = date.getDate().toString().padStart(2, '0');
        const h = date.getHours().toString().padStart(2, '0');
        const min = date.getMinutes().toString().padStart(2, '0');
        const s = date.getSeconds().toString().padStart(2, '0');
        return `${y}-${m}-${d} ${h}:${min}:${s}`;
    },
    openSyncDialog() {
      this.syncDialogVisible = true;
    },
    onSyncDialogOpen() {
      this.deptBindQuery.pageNo = 1;
      this.selectedAdsDeptRow = null;
      this.importParentDeptId = undefined;
      this.adsDeptKeyword = '';
      this.loadAdsDeptTree();
      this.loadDeptBinds();
      this.getDeptTreeselect();
    },
    filterFlatWithAncestors(flat, keyword) {
      if (!flat || !flat.length) {
        return [];
      }
      const kw = keyword != null ? String(keyword).trim().toLowerCase() : '';
      if (!kw) {
        return flat.slice();
      }
      const byId = {};
      flat.forEach((n) => {
        byId[n.deptId] = n;
      });
      const matchIds = new Set();
      flat.forEach((n) => {
        const name = (n.deptName || '').toLowerCase();
        const idStr = String(n.deptId);
        if (name.includes(kw) || idStr.includes(kw)) {
          matchIds.add(n.deptId);
          let cur = n;
          while (cur && cur.parentId != null && cur.parentId !== 0 && byId[cur.parentId]) {
            matchIds.add(cur.parentId);
            cur = byId[cur.parentId];
          }
        }
      });
      return flat.filter((n) => matchIds.has(n.deptId));
    },
    applyAdsDeptFilter() {
      const flatFiltered = this.filterFlatWithAncestors(this.adsDeptFlatFull, this.adsDeptKeyword);
      this.adsDeptTree = this.flatAdsDeptToTreeFlat(flatFiltered);
    },
    flatAdsDeptToTreeFlat(flat) {
      if (!flat || !flat.length) {
        return [];
      }
      const map = {};
      flat.forEach((n) => {
        map[n.deptId] = Object.assign({}, n, { children: [] });
      });
      const roots = [];
      flat.forEach((n) => {
        const node = map[n.deptId];
        const pid = n.parentId;
        if (pid == null || pid === 0 || !map[pid]) {
          roots.push(node);
        } else {
          map[pid].children.push(node);
        }
      });
      const strip = (nodes) => {
        nodes.forEach((node) => {
          if (node.children && node.children.length === 0) {
            delete node.children;
          } else if (node.children) {
            strip(node.children);
          }
        });
      };
      strip(roots);
      return roots;
    },
    async loadAdsDeptTree() {
      this.adsDeptTreeLoading = true;
      try {
        const res = await fetchAdsDeptTree({ skipErrorMessage: true });
        const flat = res && res.data ? res.data : [];
        this.adsDeptFlatFull = flat;
        this.applyAdsDeptFilter();
      } catch (e) {
        this.adsDeptFlatFull = [];
        this.adsDeptTree = [];
        this.$message.warning(
          "拉取投放部门失败：请确认使用内置超级管理员（用户ID=1）、B 端已配置 ads-backend，且投放端已部署部门树接口"
        );
      } finally {
        this.adsDeptTreeLoading = false;
      }
    },
    handleAdsDeptRowClick(row) {
      this.selectedAdsDeptRow = row;
    },
    async handleBindExistDept() {
      if (!this.selectedAdsDeptRow || !this.bindExistDeptId) {
        return;
      }
      this.bindExistSubmitting = true;
      try {
        await saveDeptAdsBind(this.bindExistDeptId, {
          adsDeptId: this.selectedAdsDeptRow.deptId,
          adsDeptName: this.selectedAdsDeptRow.deptName
        });
        this.$message.success('绑定成功');
        this.loadDeptBinds();
        this.loadAdsDeptTree();
        this.getDeptTreeselect();
        this.fetchList();
        this.bindExistDeptId = undefined;
      } catch (e) {
        /* 全局错误提示 */
      } finally {
        this.bindExistSubmitting = false;
      }
    },
    async handleImportAdsDept() {
      if (!this.selectedAdsDeptRow) {
        return;
      }
      let parentId = this.importParentDeptId;
      if (parentId === undefined || parentId === null || parentId === "") {
        
        parentId = null;
      } else {
        parentId = Number(parentId);
      }
      this.importDeptSubmitting = true;
      try {
        await importAdsDept({
          adsDeptId: this.selectedAdsDeptRow.deptId,
          parentAiDeptId: parentId,
          adsDeptName: this.selectedAdsDeptRow.deptName
        });
        this.$message.success("已导入部门并建立映射");
        this.loadDeptBinds();
        this.getDeptTreeselect();
        this.fetchList();
      } catch (e) {
        /* 全局错误提示 */
      } finally {
        this.importDeptSubmitting = false;
      }
    },
    handleDeptBindSearch() {
      this.deptBindQuery.pageNo = 1;
      this.loadDeptBinds();
    },
    handleDeptBindPageChange(p) {
      this.deptBindQuery.pageNo = p;
      this.loadDeptBinds();
    },
    async loadDeptBinds() {
      this.deptBindLoading = true;
      try {
        const res = await listDeptAdsBinds({
          keyword: this.deptBindQuery.keyword || undefined,
          pageNo: this.deptBindQuery.pageNo,
          pageSize: this.deptBindQuery.pageSize
        });
        const data = res && res.data ? res.data : {};
        this.deptBindList = (data.records || []).map(function(row) {
          return Object.assign({ _syncing: false }, row);
        });
        this.deptBindTotal = data.total != null ? data.total : 0;
      } catch (e) {
        this.deptBindList = [];
        this.deptBindTotal = 0;
      } finally {
        this.deptBindLoading = false;
      }
    },
    async handleSyncOneDept(row) {
      if (!row || row.aiDeptId == null) {
        return;
      }
      this.$set(row, '_syncing', true);
      try {
        const res = await syncFromAdsDept(row.aiDeptId);
        const d = res && res.data ? res.data : {};
        var msg = '拉取 ' + (d.fetchedFromAds != null ? d.fetchedFromAds : 0) + ' 条；新建 ' + (d.created != null ? d.created : 0) + '，跳过 ' + (d.skipped != null ? d.skipped : 0);
        this.$message.success(msg);
        this.fetchList();
      } catch (e) {
        /* 全局错误提示 */
      } finally {
        this.$set(row, '_syncing', false);
      }
    },
    openUserBindLookup() {
      this.userBindDialogVisible = true;
    },
    onUserBindDialogOpen() {
      this.userBindQuery.pageNo = 1;
      this.loadUserBinds();
    },
    handleUserBindSearch() {
      this.userBindQuery.pageNo = 1;
      this.loadUserBinds();
    },
    handleUserBindPageChange(p) {
      this.userBindQuery.pageNo = p;
      this.loadUserBinds();
    },
    async loadUserBinds() {
      this.userBindLoading = true;
      try {
        const res = await listUserAdsBinds({
          keyword: this.userBindQuery.keyword || undefined,
          pageNo: this.userBindQuery.pageNo,
          pageSize: this.userBindQuery.pageSize
        });
        const data = res && res.data ? res.data : {};
        this.userBindList = data.records || [];
        this.userBindTotal = data.total != null ? data.total : 0;
      } catch (e) {
        this.userBindList = [];
        this.userBindTotal = 0;
      } finally {
        this.userBindLoading = false;
      }
    },
    openAddUserBindDialog() {
      this.manageBindSysUserId = null;
      this.manageBindAdsUsers = [];
      this.manageBindSelectedAdsUserIds = [];
      this.loadAllLocalUsers();
      this.addUserBindVisible = true;
    },
    async loadAllLocalUsers() {
      this.localUserSearchLoading = true;
      try {
        var res = await listUsers({ pageNo: 1, pageSize: 200 });
        var data = res && res.data ? res.data : {};
        this.localUserOptions = data.records || [];
      } catch (e) {
        this.localUserOptions = [];
      } finally {
        this.localUserSearchLoading = false;
      }
    },
    async onManageBindUserChange(sysUserId) {
      if (!sysUserId) {
        this.manageBindAdsUsers = [];
        return;
      }
      this.manageBindAdsUsersLoading = true;
      try {
        var existBindsRes = await listUserAdsBinds({ keyword: String(sysUserId), pageNo: 1, pageSize: 100 });
        var existData = existBindsRes && existBindsRes.data ? existBindsRes.data : {};
        var existRecords = existData.records || [];
        var existAdsIds = new Set();
        existRecords.forEach(function(r) {
          if (r.sysUserId === sysUserId && r.adsUserId) {
            existAdsIds.add(r.adsUserId);
          }
        });
        var allAdsUsers = [];
        try {
          var usersRes = await listAllAdsUsers();
          var users = usersRes && usersRes.data ? usersRes.data : [];
          users.forEach(function(u) {
            if (u.userId) {
              allAdsUsers.push(u);
            }
          });
        } catch (e) {
          console.warn('拉取A系统全量用户失败', e);
        }
        this.manageBindAdsUsers = allAdsUsers;
        var self = this;
        this.$nextTick(function() {
          if (self.$refs.manageBindTable) {
            allAdsUsers.forEach(function(row) {
              if (existAdsIds.has(row.userId)) {
                self.$refs.manageBindTable.toggleRowSelection(row, true);
              }
            });
          }
        });
      } catch (e) {
        this.manageBindAdsUsers = [];
        console.warn('加载映射数据失败', e);
      } finally {
        this.manageBindAdsUsersLoading = false;
      }
    },
    onManageBindSelectionChange(selection) {
      this.manageBindSelectedAdsUserIds = selection.map(function(r) { return r.userId; });
    },
    async submitManageBind() {
      if (!this.manageBindSysUserId) {
        return;
      }
      this.addUserBindSubmitting = true;
      try {
        await batchSaveUserAdsBinds({
          sysUserId: this.manageBindSysUserId,
          adsUserIds: this.manageBindSelectedAdsUserIds
        });
        this.$message.success('映射保存成功');
        this.addUserBindVisible = false;
        this.loadUserBinds();
      } catch (e) {
        /* 全局错误提示 */
      } finally {
        this.addUserBindSubmitting = false;
      }
    },
    handleDeleteUserBind(row) {
      this.$confirm('确认删除该用户映射？（本系统用户: ' + (row.username || row.sysUserId) + ' ↔ 投放用户ID: ' + row.adsUserId + '）', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        try {
          await deleteUserAdsBind(row.bindId);
          this.$message.success('删除成功');
          this.loadUserBinds();
        } catch (e) {
          /* 全局错误提示 */
        }
      }).catch(() => {});
    },
    async handleDeleteDeptBind(row) {
      this.$confirm('确认解除该部门映射？（B部门: ' + (row.aiDeptName || row.aiDeptId) + ' ↔ A部门ID: ' + row.adsDeptId + '）\n解除后该部门下的用户映射不受影响。', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        try {
          await deleteDeptAdsBind(row.adsDeptId);
          this.$message.success('已解除部门映射');
          this.loadDeptBinds();
          this.loadAdsDeptTree();
        } catch (e) {
          /* 全局错误提示 */
        }
      }).catch(() => {});
    }
  }
};
</script>

<style scoped>
.app-container {
  padding: 0;
  background-color: #f8f8f9;
  min-height: calc(100vh - 84px);
}

.query-card {
  border: none;
}

.mb8 {
  margin-bottom: 8px;
}

.right-tool {
  float: right;
}

.pagination-container {
  margin-top: 20px;
  text-align: right;
}

.el-dropdown-link {
  cursor: pointer;
  color: #1890ff;
  font-size: 12px;
  margin-left: 10px;
}

.el-table th {
  background-color: #f8f8f9 !important;
  color: #515a6e;
}

.el-form-item__label {
  font-weight: 700;
}

.danger-text {
  color: #ff4d4f !important;
}

.danger-text:hover {
  color: #ff7875 !important;
}

.operation-cell {
  display: flex;
  justify-content: center;
  align-items: center;
  white-space: nowrap;
}

.operation-cell .el-button,
.operation-cell .el-dropdown {
  margin: 0 5px;
}
</style>
